module.exports = __webpack_public_path__ + "static/DarksideDetective6-06bf5842fd52350356e33145e5c3337a.png";